import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/layout.vue";
import LoginView from "@/views/login/index.vue";
import RegisterView from "@/views/registerIntermediatePage/index.vue";
import ResetView from "@/views/resetPassword/index.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "/login",
      children: [
        // 登录页
        {
          path: "/login",
          name: "Login",
          component: LoginView,
        },
        // 注册中间页
        {
          path: "/registerIntermediatePage",
          name: "RegisterIntermediatePage",
          component: RegisterView,
        },
        // 忘记密码
        {
          path: "/resetPassword",
          name: "ResetPassword",
          component: ResetView,
        },
      ],
    },
  ],
});

export default router;
